import { jsx, Fragment } from "react/jsx-runtime";
import { memo } from "react";
import { SortableHandle } from "react-sortable-hoc";
const SortableRepeaterItemHandle = memo(SortableHandle(({ children }) => /* @__PURE__ */ jsx(Fragment, { children })));
SortableRepeaterItemHandle.displayName = "SortableRepeaterItemHandle";
export {
  SortableRepeaterItemHandle
};
//# sourceMappingURL=SortableRepeaterItemHandle.js.map
